<template>
  <div class="recipe">
    <myNav />
    <div class="bannery">
      <h1>利源诚企服课件</h1>
      <h2>专业代账的网站</h2>
      <div class="input_s">
        <img src="../assets/images/ss.png" class="input_ss" />
        <el-input
          v-model="keyword"
          placeholder="请输入内容"
          v-on:keyup.native="search(keyword)"
          class="upinput"
        ></el-input>
      </div>
      <router-link class="ckxq" :to="{ name: 'rz' }"
        ><p>公司入驻</p></router-link
      >
    </div>
    <div class="y1200">
      <div class="list" v-for="(item, index) in list" :key="index">
        <div class="list_left">
          <h1>{{ item.goods_title }}</h1>
          <p v-html="item.goods_content"></p>
          <button @click="checkVideoFun(item.goods_audio)">点击播放</button>
        </div>
        <div class="list_right">
          <video controls="controls" :src="item.goods_audio" />
        </div>
      </div>
      <!-- 外层的遮罩 v-if用来控制显示隐藏 点击事件用来关闭弹窗 -->
      <div class="mask" v-if="videoState == true" @click="masksCloseFun"></div>
      <!-- 弹窗 -->
      <div class="videomasks" v-if="videoState == true">
        <!-- 视频：h5的视频播放video -->
        <video :src="src" controls="controls" autoplay class="video1"></video>
      </div>
      <!-- <video controls="controls" :src="src" /> -->
      <el-pagination
        class="page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current_page"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="count"
      >
      </el-pagination>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/footer";
export default {
  components: {
    Footer,
  },
  data() {
    return {
      keyword: "",
      list: [],
      page: 1,
      pageSize: 10,
      current_page: 1,
      count: 0,
      videoSrc: "",
      videoState: false,
    };
  },
  created() {
    this.get();
  },
  methods: {
    //点击按钮出现弹窗播放视频
    checkVideoFun(videos) {
      this.videoState = true;
      this.src = videos;
    },
    masksCloseFun() {
      this.videoState = false;
    },
    get() {
      this.$axios({
        url: "/Index/video_list",
        method: "GET",
        params: {
          page: this.current_page,
          pageSize: this.pageSize,
          keyword: this.keyword,
        },
      }).then((res) => {
        console.log("我可以获取到审计列表数据吗", res);
        this.list = res.data.data.list;
        this.count = Number(res.data.data.count);
        this.current_page = res.data.data.page;
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.get();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.current_page = val;
      this.get();
    },
    todetail(e) {
      this.$router.push({
        path: "sj_detail",
        query: {
          admin_id: e,
        },
      });
    },
    search(keyword) {
      this.keyword = keyword;
      this.get();
    },
  },
};
</script>
<style scoped lang="less">
.list {
  width: 100%;
  height: 220px;
  padding-top: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #e5e5e5;
}
.list_left {
  float: left;
  width: 75%;
}
.list_right {
  float: right;
  width: 267px;
  height: 180px;
  border: 1px solid #000;
  border-radius: 5px;
  
}
.list_right video {
  object-fit: cover;
  width: 267px;
  height: 180px;
}
.list_left h1 {
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list_left p {
  padding-top: 30px;
  font-size: 18px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 60px;
}
.list_left button {
  margin-top: 50px;
  width: 78px;
  height: 27px;
  border-radius: 5px;
  border: 1px solid;
  color: #558bd4;
  line-height: 27px;
  text-align: center;
}
.page {
  padding-top: 20px;
  padding-bottom: 20px;
}
.bannery h1 {
  text-align: center;
  padding-top: 118px;
  font-size: 30px;
  color: #fff;
}
.bannery h2 {
  text-align: center;
  padding-top: 14px;
  font-size: 20px;
  color: #fff;
}
.bannery p {
  width: 100px;
  height: 44px;
  border: 1px solid;
  border-radius: 5px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  line-height: 44px;
  display: block;
  margin: 0 auto;
  margin-top: 65px;
}
.input_s {
  padding-top: 80px;
  margin: 0 auto;
  width: 500px;
  height: 40px;
  display: block;
  position: relative;
}
.input_ss {
  right: 10px;
  top: 90px;
  position: absolute;
  z-index: 500000;
}
.upinput {
  width: 500px;
  height: 40px;
  display: block;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background-color: #000000;
  opacity: 0.6;
}
.videomasks {
  max-width: 1200px;
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 20;
  transform: translate(-50%, -50%);
}
.videomasks video {
  width: 100%;
  height: 100%;
}
.video1 {
  width: 500px !important;
  height: 300px !important;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #281bcc;
}
</style>

